import React, { useState, useEffect, useContext } from 'react'
import { ProductContext } from './ProductContext'

export default function PerformanceOptions({
  performanceTypeOptions,
  primaryBenchmarkName,
  selectedPerformanceFrequency,
  selectedDisplayBenchmark,
  selectedDisplayMorningstar,
  onChangePerformanceType,
  onChangePerformanceFrequency,
  onChangeDisplayBenchmark,
  onChangeDisplayMorningstar,
}) {
  const onChangePerformanceTypeDropdown = (event) => {
    onChangePerformanceType(event)
  }

  const onChangePerformanceFrequencyDropdown = (event) => {
    onChangePerformanceFrequency(event)
  }

  const onChangeDisplayBenchmarkCheckbox = (event) => {
    onChangeDisplayBenchmark(event)
  }

  const onChangeDisplayMorningstarCheckbox = (event) => {
    onChangeDisplayMorningstar(event)
  }

  const { isMobile } = useContext(ProductContext)

  return (
    <>
      <div className={`u-lg-flex ${isMobile && 'Grid Grid--withGutter'}`}>
        <div
          className={`u-lg-flex u-lg-flexAlignItemsCenter ${isMobile && 'u-size1of2'}`}
        >
          <label className="u-sm-hiddenVisually" htmlFor="performance_dropdown">
            Performance
          </label>
          <div className="Dropdown u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft2gu">
            <select
              id="performance_dropdown"
              className="Dropdown-menu u-md-marginBottom3gu"
              data-qa-automation={'performanceDropdown'}
              onChange={onChangePerformanceTypeDropdown}
            >
              {performanceTypeOptions()}
            </select>
          </div>
        </div>
        <div
          className={`u-lg-flex u-lg-flexAlignItemsCenter ${isMobile && 'u-size1of2'}`}
        >
          <div className="Dropdown u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft2gu">
            <label className="u-hiddenVisually" htmlFor="frequency_dropdown">
              Frequency
            </label>
            <select
              id="frequency_dropdown"
              data-qa-automation={'frequencyDropdown'}
              className="Dropdown-menu u-md-marginBottom3gu"
              value={selectedPerformanceFrequency}
              onChange={onChangePerformanceFrequencyDropdown}
            >
              <option value="Monthly">MONTHLY</option>
              <option value="Quarterly">QUARTERLY</option>
            </select>
          </div>
        </div>
      </div>
      <div className="u-lg-flex">
        <div className="Checkbox u-md-marginBottom3gu">
          <input
            type="checkbox"
            id={'primaryBenchmarkCheckbox'}
            data-qa-automation={'primaryBenchmarkCheckbox'}
            className="Checkbox-button u-posRelative"
            checked={selectedDisplayBenchmark}
            onChange={onChangeDisplayBenchmarkCheckbox}
            data-analytics="simple-entry-component-body-performance-benchmark-chbx"
          ></input>
          <label
            htmlFor={'primaryBenchmarkCheckbox'}
            className="Checkbox-label"
          >
            <div className="u-textNoWrap u-sm-textSizeMsrm1">
              {primaryBenchmarkName}
            </div>
          </label>
        </div>
        <div className="Checkbox u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft5gu">
          <input
            type="checkbox"
            id={'morningstarCheckbox'}
            data-qa-automation={'morningstarCheckbox'}
            className="Checkbox-button u-posRelative"
            checked={selectedDisplayMorningstar}
            onChange={onChangeDisplayMorningstarCheckbox}
            data-analytics="simple-entry-component-body-morningstar-avg-chbx"
          ></input>
          <label htmlFor={'morningstarCheckbox'} className="Checkbox-label">
            <div className="u-textNoWrap u-sm-textSizeMsrm1">
              Morningstar Category Average
            </div>
          </label>
        </div>
      </div>
    </>
  )
}
